import { eventTracker } from 'app/modules/Segment';
import {
  buildJusfyEventsContext,
  buildJusfyEventsProperties,
} from 'app/modules/Segment/buildJusfyEvent';
import { FeatureEnum, TContext } from 'app/modules/Segment/types';

const ONBOARDING_CREDITS_POLLING_STARTED_EVENT =
  'onboarding_credits_polling_started';
const ONBOARDING_CREDITS_POLLING_SUCCEEDED_EVENT =
  'onboarding_credits_polling_succeeded';
const ONBOARDING_CREDITS_POLLING_TIMED_OUT_EVENT =
  'onboarding_credits_polling_timed_out';
const ONBOARDING_CREDITS_POLLING_FAILED_EVENT =
  'onboarding_credits_polling_failed';

const onboardingCreditsPollingContext: TContext = buildJusfyEventsContext({
  component: 'onboarding-credits-polling',
});

export function trackOnboardingCreditsPollingStarted(): void {
  eventTracker.track({
    event: ONBOARDING_CREDITS_POLLING_STARTED_EVENT,
    properties: buildJusfyEventsProperties({
      event: ONBOARDING_CREDITS_POLLING_STARTED_EVENT,
      feature: FeatureEnum.ONBOARDING,
      eventMeaning:
        '[Onboarding] Conta recente (criada há menos de 24h) chegou no primeiro acesso sem crédito ainda propagado (/credits/resume sem hasSubscription/hasBonus). O onboarding passou a fazer polling em vez de deixar os steps estourarem 402. Evento passivo, não é ação do usuário.',
      relevantUserActivity: false,
    }),
    context: onboardingCreditsPollingContext,
  });
}

export function trackOnboardingCreditsPollingSucceeded(
  durationMs: number,
): void {
  eventTracker.track({
    event: ONBOARDING_CREDITS_POLLING_SUCCEEDED_EVENT,
    properties: buildJusfyEventsProperties({
      event: ONBOARDING_CREDITS_POLLING_SUCCEEDED_EVENT,
      feature: FeatureEnum.ONBOARDING,
      eventMeaning:
        '[Onboarding] O crédito chegou durante o polling de /credits/resume no primeiro acesso; duration_ms mede o tempo de propagação observado. Evento passivo, não é ação do usuário.',
      relevantUserActivity: false,
      extraProperties: {
        duration_ms: durationMs,
      },
    }),
    context: onboardingCreditsPollingContext,
  });
}

export function trackOnboardingCreditsPollingTimedOut(
  durationMs: number,
): void {
  eventTracker.track({
    event: ONBOARDING_CREDITS_POLLING_TIMED_OUT_EVENT,
    properties: buildJusfyEventsProperties({
      event: ONBOARDING_CREDITS_POLLING_TIMED_OUT_EVENT,
      feature: FeatureEnum.ONBOARDING,
      eventMeaning:
        '[Onboarding] O polling de /credits/resume no primeiro acesso esgotou a janela de espera sem encontrar crédito; o usuário segue para o fluxo real de paywall. Evento passivo, não é ação do usuário.',
      relevantUserActivity: false,
      extraProperties: {
        duration_ms: durationMs,
      },
    }),
    context: onboardingCreditsPollingContext,
  });
}

export function trackOnboardingCreditsPollingFailed(
  durationMs: number,
): void {
  eventTracker.track({
    event: ONBOARDING_CREDITS_POLLING_FAILED_EVENT,
    properties: buildJusfyEventsProperties({
      event: ONBOARDING_CREDITS_POLLING_FAILED_EVENT,
      feature: FeatureEnum.ONBOARDING,
      eventMeaning:
        '[Onboarding] O polling de /credits/resume no primeiro acesso foi interrompido por um erro (ex.: 4xx), não por esgotar a janela de espera; o usuário segue para o fluxo real de paywall. Evento passivo, não é ação do usuário.',
      relevantUserActivity: false,
      extraProperties: {
        duration_ms: durationMs,
      },
    }),
    context: onboardingCreditsPollingContext,
  });
}

export {
  ONBOARDING_CREDITS_POLLING_STARTED_EVENT,
  ONBOARDING_CREDITS_POLLING_SUCCEEDED_EVENT,
  ONBOARDING_CREDITS_POLLING_TIMED_OUT_EVENT,
  ONBOARDING_CREDITS_POLLING_FAILED_EVENT,
};
